import { useState } from "react";

import dictApi, { del } from "@/apis/dict";
import customerApi from "@/apis/customer";
import saleApi from "@/apis/order";
import purchaseApis from "@/apis/purchase";
import { categoryList } from "@/apis/product";
import { orgFetchs } from "@/apis/org";

import { Org } from "@/types/org";
import { DictEnum, DictItem, DictLike, DictLikeNumberKey } from "@/types/dict";
import { ProductCategory } from "@/types/product";
import { addressList } from "@/apis/address";
import { WAddress } from "@/types/address";
import { locationTypes as locationTypesApi } from "@/apis/inventoryv2";
import { orderStatus, shipMethods as shipMethodsApi, shipLogistcs as shipLogistcsApi, shipEvents as shipEventsApi } from "@/apis/shipment";
import { packageTypes as packageTypesApi } from "@/apis/packing";

const useGetBasicInfo = () => {
  const [orgs, setOrgs] = useState<Array<Org>>([]);

  const [creditLevels, setCreditLevels] = useState<Array<DictLike>>([]);
  const [currencys, setCurrencys] = useState<Array<DictLike>>([]);
  const [categories, setCategories] = useState<Array<ProductCategory>>([]); // 顶级分类

  // saleOrder
  const [saleOrderTypes, setSaleOrderTypes] = useState<Array<DictLike>>([]);
  const [saleTypes, setSaleTypes] = useState<Array<DictItem>>([]);
  const [saleTradeTerm, setSaleTradeTerm] = useState<Array<DictItem>>([]);
  const [salePayMethod, setSalePayMethod] = useState<Array<DictItem>>([]);
  const [saleShippingMethod, setSaleShippingMethod] = useState<Array<DictItem>>([]);
  const [saleCustomerType, setSaleCustomerType] = useState<Array<DictItem>>([]);

  const [purchaseOrderTypes, setPurchaseOrderTypes] = useState<Array<DictLike>>([]);
  const [purchaseTradeTerm, setPurchaseTradeTerm] = useState<Array<DictItem>>([]);
  const [purchasePayMethod, setPurchasePayMethod] = useState<Array<DictItem>>([]);

  const [address, setAddress] = useState<Array<DictItem>>([]);
  const [exchangeRate, setExchangeRate] = useState<Array<DictItem>>([]);
  const [printSetting, setPrintSetting] = useState<Array<DictItem>>([]);
  const [addressData, setAddressData] = useState<Array<WAddress>>([]);
  const [brandData, setBrandData] = useState<Array<DictItem>>([]);
  const [purchaseRule, setPurchaseRule] = useState<Array<DictItem>>([]);
  const [productType, setProductType] = useState<Array<DictItem>>([]);
  const [locationTypes, setLocationTypes] = useState<Array<DictLikeNumberKey>>([]);
  const [shipStatus, setShipStatus] = useState<Array<DictLikeNumberKey>>([]);
  const [shipMethods, setShipMethods] = useState<Array<DictLikeNumberKey>>([]);
  const [shipLogistics, setShipLogistics] = useState<Array<DictLikeNumberKey>>([]);
  const [shipEvents, setShipEvents] = useState<Array<DictLikeNumberKey>>([]);
  const [packageTypes, setpackageTypes] = useState<Array<DictLike>>([]);

  // const curUser = useSelector((state: RootState) => state.userReducer.curUser);

  // 管理员自动初始化品牌相关字典（产品类型 / 品牌名称 / 品牌型号）
  // existDescOf: 从 getDictList 拉取的全量字典中取指定 type 的 desc 列表
  // const initBrandDicts = async (dicts: Array<DictItem>) => {
  //   // for (let i = 0; i < dicts.length; i++) {
  //   //   const element = dicts[i];
  //   //   if (!oldDicids.includes(element.id)) await del(element.id)
  //   // }
  //   const existDescOf = (type: string) => dicts.filter(dict => dict.type === type).map(dict => dict.desc);
  //   // 产品类型
  //   await initProductType(DictEnum.PRODUCT_TYPE, existDescOf(DictEnum.PRODUCT_TYPE));
  //   // 品牌名称（按产品类型逐类初始化）
  //   for (const pt of productTypeList) {
  //     await initBrandName(pt, existDescOf(pt));
  //   }
  //   // 品牌型号：挂在 `${产品类型}-${品牌名称}` 组合 type 下，同一品牌在不同产品类型下各存一份
  //   for (const pt of productTypeList) {
  //     for (const brand of brandNamesByProductType[pt] ?? []) {
  //       await initBrandModel(pt, brand, existDescOf(brandModelType(pt, brand)));
  //     }
  //   }
  // };

  const getInfo = () => {
    getRootCategories()
    getOrgs();
    getDictList();
    getCurrency();
    getCreditLevels();
    getSaleOrderTypes();
    getPurchaseOrderTypes();
    getLocationTypes();
    getShipStatus();
    getShipMethods();
    getShipLogistcs();
    getShipEvents();
    getpackageTypes();
    getAddress();
  }

  const getCreditLevels = () => {
    customerApi
      .creditLevels()
      .then((res) =>
        setCreditLevels(
          res.map((item) => ({ ...item, key: item.key.toString() }))
        )
      );
  };

  const getCurrency = () => {
    customerApi
      .currencyTypes()
      .then((res) =>
        setCurrencys(res.map((item) => ({ ...item, key: item.key.toString() })))
      );
  };

  const getOrgs = () => {
    orgFetchs().then((res) => setOrgs(res.body));
  };

  const getDictList = () => {
    dictApi.list().then((dicts) => {
      const saleTypes: Array<DictItem> = [];
      const saleTradeTerm: Array<DictItem> = [];
      const salePayMethod: Array<DictItem> = [];
      const saleShippingMethod: Array<DictItem> = [];
      const saleCustomerType: Array<DictItem> = [];
      const purchaseTradeTerm: Array<DictItem> = [];
      const purchasePayMethod: Array<DictItem> = [];
      const address: Array<DictItem> = [];
      const exchangeRate: Array<DictItem> = [];
      const printSetting: Array<DictItem> = [];
      const brandData: Array<DictItem> = [];
      const purchaseRule: Array<DictItem> = [];
      const productType: Array<DictItem> = [];
      dicts.forEach((dict) => {
        if (dict.type === DictEnum.SALE_TYPE) {
          saleTypes.push(dict);
        } else if (dict.type === DictEnum.SALE_TRADE_TERM) {
          saleTradeTerm.push(dict);
        } else if (dict.type === DictEnum.SALE_PAY_METHOD) {
          salePayMethod.push(dict);
        } else if (dict.type === DictEnum.SALE_SHIPPING_METHOD) {
          saleShippingMethod.push(dict);
        } else if (dict.type === DictEnum.SALE_CUSTOMER_TYPE) {
          saleCustomerType.push(dict);
        } else if (dict.type === DictEnum.PURCHASE_TRADE_TERM) {
          purchaseTradeTerm.push(dict);
        } else if (dict.type === DictEnum.PURCHASE_PAY_METHOD) {
          purchasePayMethod.push(dict);
        } else if (dict.type === DictEnum.ADDRESS_MANAGE) {
          address.push(dict);
        } else if (dict.type === DictEnum.EXCHANGE_RATE) {
          exchangeRate.push(dict);
        } else if (dict.type === DictEnum.PRINT_SETTING) {
          printSetting.push(dict);
        } else if (dict.type === DictEnum.BRAND) {
          brandData.push(dict);
        } else if (dict.type === DictEnum.PURCHASE_RULE) {
          purchaseRule.push(dict)
        } else if (dict.type === DictEnum.PRODUCT_TYPE) {
          productType.push(dict)
        }
      });

      setSaleTypes(saleTypes);
      setSaleTradeTerm(saleTradeTerm);
      setSalePayMethod(salePayMethod);
      setSaleShippingMethod(saleShippingMethod);
      setSaleCustomerType(saleCustomerType);
      setPurchaseTradeTerm(purchaseTradeTerm);
      setPurchasePayMethod(purchasePayMethod);
      setAddress(address);
      setExchangeRate(exchangeRate);
      setPrintSetting(printSetting);
      setBrandData(brandData);
      setPurchaseRule(purchaseRule);
      setProductType(productType);
      // 全量字典就绪后，管理员自动初始化品牌相关字典
      // if (isAdmin(curUser)) initBrandDicts(dicts);
    });
  };

  const getPurchaseOrderTypes = () => {
    purchaseApis.types().then((res) => setPurchaseOrderTypes(res.map(item => ({ key: item.key.toString(), desc: item.desc }))))
  }
  const getLocationTypes = () => {
    locationTypesApi()
      .then(res => setLocationTypes(res.map(item => ({ key: item.key, desc: item.desc }))))
  };
  const getShipStatus = () => {
    orderStatus()
      .then(res => setShipStatus(res.map(item => ({ key: item.key, desc: item.desc }))))
  };
  const getShipMethods = () => {
    shipMethodsApi()
      .then(res => setShipMethods(res.map(item => ({ key: item.key, desc: item.desc }))))
  };
  const getShipLogistcs = () => {
    shipLogistcsApi()
      .then(res => setShipLogistics(res.map(item => ({ key: item.key, desc: item.desc }))))
  };
  const getShipEvents = () => {
    shipEventsApi()
      .then(res => setShipEvents(res.map(item => ({ key: item.key, desc: item.desc }))))
  };
  const getpackageTypes = () => {
    packageTypesApi()
      .then(res => setpackageTypes(res.map((item) => ({ key: item.desc, desc: item.desc }))))
  };

  const getSaleOrderTypes = () => {
    saleApi.orderTypes().then((res) => setSaleOrderTypes(res.map(item => ({ ...item, key: item.key.toString() }))))
  }

  const getRootCategories = async () => {
    const res = await categoryList();
    setCategories(() => res.body.filter(item => item.pId === null));
  }

  const getAddress = () => {
    addressList().then(res => setAddressData(res))
  };

  return {
    creditLevels,
    currencys,
    orgs,
    saleTypes,
    saleTradeTerm,
    salePayMethod,
    saleShippingMethod,
    saleCustomerType,
    saleOrderTypes,
    purchaseTradeTerm,
    purchasePayMethod,
    purchaseOrderTypes,
    address,
    exchangeRate,
    printSetting,
    addressData,
    brandData,
    purchaseRule,
    productType,
    locationTypes,
    shipStatus,
    shipMethods,
    shipLogistics,
    shipEvents,
    packageTypes,
    setSaleTypes,
    setSaleTradeTerm,
    setSalePayMethod,
    setSaleShippingMethod,
    setSaleCustomerType,
    setPurchaseTradeTerm,
    setPurchasePayMethod,
    setAddress,
    setExchangeRate,
    setPrintSetting,
    setAddressData,
    setBrandData,
    setPurchaseRule,
    setProductType,
    rootCategories: categories,
    getInfo,
  };
};

export default useGetBasicInfo;
